import { InArticlePollingOptions } from "consts";

export const targetInArticlePollingOptions: Readonly<{ text: string; value: string }[]> = [
  { text: "None", value: InArticlePollingOptions.none },
  { text: "Allowed", value: InArticlePollingOptions.allowed },
  { text: "Required", value: InArticlePollingOptions.required },
  { text: "Target", value: InArticlePollingOptions.meta },
];

type TargetCustomizationSizeArgs = {
  viewportUnit: "width" | "height";
};

export const getTargetCustomizationSizeOptions = ({
  viewportUnit,
}: TargetCustomizationSizeArgs): Readonly<{ text: string; value: string }[]> => {
  return [
    { text: "px", value: "px" },
    { text: "%", value: "%" },
    ...(viewportUnit === "width" ? [{ text: "vw", value: "vw" }] : []),
    ...(viewportUnit === "height" ? [{ text: "vh", value: "vh" }] : []),
  ];
};

export const targetQgenQueueOptions: Readonly<{ text: string; value: string }[]> = [
  { text: "News", value: "NEWS" },
  { text: "Sports", value: "SPORTS" },
  { text: "Entertainment", value: "ENTERTAINMENT" },
  { text: "Lifestyle", value: "LIFESTYLE" },
  { text: "Spanish", value: "SPANISH" },
  { text: "Hearst", value: "HEARST" },
  { text: "Others", value: "OTHERS" },
  { text: "Off", value: "OFF" },
];

export const targetQgenModelOptions: Readonly<{ text: string; value: string }[]> = [
  { text: "Fine Tuned", value: "finetuned" },
  { text: "Short", value: "short" },
];
